<template>
  <div :class="[$style.personage, $style.analyticsBlock]">
    <span :class="$style.title">Выбранный портрет</span>
    <div :class="$style.imgWrapper">
      <img :src="require(`@/assets/lesson4/task1/${cityImage}`)" :class="$style.city" alt="city">
      <transition name="fade">
      <img v-if="characterImg" :src="require(`@/assets/lesson4/task1/character_${characterImg}.png`)" :class="$style.characterImg" alt="character">
      </transition>
    </div>
    <p :class="$style.description">{{description}}</p>
  </div>
</template>

<script>
export default {
  name: 'personage',
  props: {
    cityImage: String,
    characterImg: Number,
    description: String,
  },
}
</script>

<style lang="scss" module>
  .personage {
    width: 28%;
    height: max-content;
    .title {
      margin: 2rem 2rem 1rem 2rem;
    }
    .imgWrapper {
      position: relative;
      overflow: hidden;
      .city {
        width: 100%;
        height: 100%;
      }
    }
    .characterImg {
      position: absolute;
      bottom: 1rem;
      left: 50%;
      width: auto;
      max-height: 90%;
      transform: translateX(-50%);
    }
    .description {
      margin: 1.3rem 3rem;
      font-size: 1.7rem;
      line-height: 1.4;
      @media #{$m-mobile} {
        font-size: 3rem;
      }
    }
    @media #{$m-mobile} {
      width: calc(100% - 4rem);
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2rem;
    }
  }
  .analyticsBlock {
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.2);
    border-radius: 3rem;
    overflow: hidden;
  }
  .title {
    display: inline-block;
    font-size: 1.35rem;
    color: black;
    opacity: 0.5;
    line-height: 1.4;
    @media #{$m-mobile} {
      font-size: 3rem;
    }
  }
</style>
